import React from 'react';
import '../styles/Hero.css';

function Hero() {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero section">
      <div className="container">
        <div className="hero-content">
          {/* Text Content */}
          <div className="hero-text">
            <h1 className="hero-title">
              AI-Powered Resume Screening That{' '}
              <span className="highlight">Actually Works</span>
            </h1>
            <p className="hero-subtitle">
              Screen thousands of resumes in seconds. Find the perfect candidate with
              intelligent matching, bias-free insights, and explainable AI that you can trust.
            </p>

            {/* CTA Buttons */}
            <div className="hero-cta">
              <a
                href="#pricing"
                className="btn btn-primary btn-large"
                onClick={(e) => scrollToSection(e, 'pricing')}
              >
                See Pricing
              </a>
              <a
                href="#features"
                className="btn btn-secondary btn-large"
                onClick={(e) => scrollToSection(e, 'features')}
              >
                Learn More
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="hero-trust">
              <div className="trust-item">
                <div className="trust-icon">✓</div>
                <span>GDPR Compliant</span>
              </div>
              <div className="trust-item">
                <div className="trust-icon">✓</div>
                <span>Bias-Free AI</span>
              </div>
              <div className="trust-item">
                <div className="trust-icon">✓</div>
                <span>100% Explainable</span>
              </div>
            </div>
          </div>

          {/* Visual Element */}
          <div className="hero-visual">
            <div className="visual-container">
              {/* Decorative shapes using CSS */}
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>

              {/* Main visual card */}
              <div className="visual-card">
                <div className="card-header">
                  <div className="card-icon">🎯</div>
                  <h3>AI Match Score</h3>
                </div>
                <div className="score-display">
                  <div className="score-circle">
                    <span className="score-number">94</span>
                    <span className="score-label">%</span>
                  </div>
                  <div className="score-details">
                    <div className="score-bar">
                      <div className="score-bar-label">Skills Match</div>
                      <div className="score-bar-track">
                        <div className="score-bar-fill" style={{ width: '92%' }}></div>
                      </div>
                    </div>
                    <div className="score-bar">
                      <div className="score-bar-label">Experience</div>
                      <div className="score-bar-track">
                        <div className="score-bar-fill" style={{ width: '96%' }}></div>
                      </div>
                    </div>
                    <div className="score-bar">
                      <div className="score-bar-label">Culture Fit</div>
                      <div className="score-bar-track">
                        <div className="score-bar-fill" style={{ width: '88%' }}></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
